import { shade } from 'polished';
import styled from 'styled-components';
import background from '../../assets/sign-up-background.png';

export const Container = styled.div`
    height: 100vh;
    display: flex;
    align-items: stretch;
`;
export const Content = styled.div`
    display: flex;
    flex-direction: column;
    place-content: center;
    align-items: center;
    width: 100%;
    max-width: 700px;
    form {
        margin: 80px;
        width: 340px;
        text-align: center;

        h1 {
            margin-bottom: 24px;
        }

        a {
            color: #f4ede8;
            display: block;
            margin-top: 24px;
            text-decoration: none;
            transition: color 0.2s;

            &:hover {
                color: ${shade(0.2, '#f4ede8')};
            }
        }
    }

    > a {
        display: flex;
        align-items: center;
        color: #ff9000;
        margin-top: 24px;
        text-decoration: none;
        transition: color 0.2s;
        svg {
            margin-right: 10px;
        }
        &:hover {
            color: ${shade(0.2, '#ff9000')};
        }
    }
`;
export const Background = styled.div`
    flex: 1;
    background: url(${background}) no-repeat center;
    background-size: cover;
`;
